import {createSelector} from "@reduxjs/toolkit";
import {ReducerStatuses} from "services/utils/utils";

const baseState = (state) => state.payments.cards;

const baseAdd = createSelector([baseState], (state) => state.add);
const baseRemove = createSelector([baseState], (state) => state.remove);

export const paymentCardsSelector = createSelector([baseState], (state) => {
    return Object.values(state.cards);
});

export const addPaymentLoading = createSelector([baseAdd], (state) => {
    return state.status === ReducerStatuses.LOADING;
});
export const addPaymentErrorSelector = createSelector([baseAdd], (state) => {
    return {
        inError: state.status === ReducerStatuses.ERROR,
        error: state.error
    };
});
export const deletePaymentErrorSelector = createSelector([baseRemove], (state) => {
    return {
        inError: state.status === ReducerStatuses.ERROR,
        error: state.error
    };
});
export const deletePaymentLoadingSelector = createSelector([baseRemove], (state) => {
    return state.status === ReducerStatuses.LOADING;
});